export const work = {
  Favorite: 'Favorite',
  Unfavorite: 'Unfavorite',
};
